module.exports = __webpack_public_path__ + "assets/img/shenqing.b05aa676.png";